import { connect } from 'react-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectOutstandingPersonalisations, selectSelectedOption } from 'src/redux/personalisation';
import { Input, OwnProps } from '../components/Input/Input';

const mapStateToProps = (state: ReduxApplicationState, props: OwnProps) => ({
  error:
    Boolean(props.displayValidation) &&
    selectOutstandingPersonalisations(state).some((opt) => opt.id === props.id),
  value: selectSelectedOption(state, props.id)?.[0]?.name,
});

export const InputContainer = connect(mapStateToProps)(Input);
